<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Introduction</a></div>
<div class="SOM_chap"><a href="#/chap1">1 Delight Yourself in God</a></div>
<div class="SOM_niv1"><a href="#/chap2">Practice—Choose Joy</a></div>
<div class="SOM_chap"><a href="#/chap3">2 Open Yourself to Awe and Wonder</a></div>
<div class="SOM_niv1"><span href="#/chap4" title="Link target outside of Sample">Practice—Ten Miracles Before Breakfast</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">3 Let Your Life Speak</span></div>
<div class="SOM_niv1"><span href="#/chap6" title="Link target outside of Sample">Practice—Listen to Your Life</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample">4 Unleash Your Inner Child</span></div>
<div class="SOM_niv1"><span href="#/chap8" title="Link target outside of Sample">Practice—Plan a Playdate</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample">5 Set Your Imagination Free</span></div>
<div class="SOM_niv1"><span href="#/chap10" title="Link target outside of Sample">Practice—Read a Children’s Book</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample">6 Give Yourself the Gift of Curiosity</span></div>
<div class="SOM_niv1"><span href="#/chap12" title="Link target outside of Sample">Practice—Walk a Finger Labyrinth</span></div>
<div class="SOM_chap"><span href="#/chap13" title="Link target outside of Sample">7 Remember We Are Earthlings</span></div>
<div class="SOM_niv1"><span href="#/chap14" title="Link target outside of Sample">Practice—Seed Bomb Our Neighborhoods</span></div>
<div class="SOM_chap"><span href="#/chap15" title="Link target outside of Sample">8 Return to the Rhythm of Life</span></div>
<div class="SOM_niv1"><span href="#/chap16" title="Link target outside of Sample">Practice—Have Fun with Leaves</span></div>
<div class="SOM_chap"><span href="#/chap17" title="Link target outside of Sample">9 Rest in the Moment</span></div>
<div class="SOM_niv1"><span href="#/chap18" title="Link target outside of Sample">Practice—Walking in Circles</span></div>
<div class="SOM_chap"><span href="#/chap19" title="Link target outside of Sample">10 Cultivate Gratitude</span></div>
<div class="SOM_niv1"><span href="#/chap20" title="Link target outside of Sample">Practice—Plan a Gratitude Scavenger Hunt</span></div>
<div class="SOM_chap"><span href="#/chap21" title="Link target outside of Sample">11 See Things Differently</span></div>
<div class="SOM_niv1"><span href="#/chap22" title="Link target outside of Sample">Practice—Make a Rainbow</span></div>
<div class="SOM_chap"><span href="#/chap23" title="Link target outside of Sample">12 Stay Close to the Cracks</span></div>
<div class="SOM_niv1"><span href="#/chap24" title="Link target outside of Sample">Practice—Shine Light in the Cracks</span></div>
<div class="SOM_chap"><span href="#/chap25" title="Link target outside of Sample">13 Come to the Table</span></div>
<div class="SOM_niv1"><span href="#/chap26" title="Link target outside of Sample">Practice—Welcome to the Manger</span></div>
<div class="SOM_chap"><span href="#/chap27" title="Link target outside of Sample">14 Embrace Trust</span></div>
<div class="SOM_niv1"><span href="#/chap28" title="Link target outside of Sample">Practice—Braid the Cords Together</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Appendix: Guidelines for Leading a Group</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Creative Practices</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>The Gift of Wonder</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?209e4456